<template>
  <div class="LineChartDisplay">
    <lineChart type="line" :options="options" :series="series" />
  </div>
</template>

<script>
import lineChart from 'vue-apexcharts';

export default {
  name: 'LineChartDisplay',
  components: {
    lineChart,
  },
  props: {
    options: {
      type: Object,
      required: true,
    },
    series: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.LineChartDisplay {
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: rem(65);
  max-width: rem(170);
}
</style>
